import React from "react";

const TextAreaSurveyInput = ({ rows = 3, defaultAnswer, handleChange }) => (
  <div className="form-group">
    <textarea
      className="form-control"
      rows={rows}
      value={defaultAnswer ?? ""}
      onChange={handleChange}
    />
  </div>
);

export default TextAreaSurveyInput;
